/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_IncludedInputs */

const tr_landing_community_tile_included = /** @type {(inputs: Landing_Community_Tile_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ dahil · ek ücret yok`)
};

const en_landing_community_tile_included = /** @type {(inputs: Landing_Community_Tile_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ included · no extra fee`)
};

const de_landing_community_tile_included = /** @type {(inputs: Landing_Community_Tile_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ inklusive · ohne Aufpreis`)
};

const ru_landing_community_tile_included = /** @type {(inputs: Landing_Community_Tile_IncludedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`✓ включено · без доплаты`)
};

/**
* | output |
* | --- |
* | "✓ included · no extra fee" |
*
* @param {Landing_Community_Tile_IncludedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_included = /** @type {((inputs?: Landing_Community_Tile_IncludedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_IncludedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_included(inputs)
	if (locale === "de") return de_landing_community_tile_included(inputs)
	if (locale === "ru") return ru_landing_community_tile_included(inputs)
	return tr_landing_community_tile_included(inputs)
});